import React, { BaseSyntheticEvent, useLayoutEffect } from "react";
import { NavLink } from "react-router-dom";
import {
  BounakirFilterType,
  GAActions,
  GACategoryName,
  GAEventNames,
  GAUniqueEventIds,
  HomeScreenType,
} from "../helpers/Enums";
import {
  BOUNAKIR,
  BOUNAKIR_WATCH_ME,
  BOUNKIR_LINKS,
  CONVERSTAION,
  HOMEPAGE,
  MY_PROFILE,
} from "../navigation/Constants";
import {
  setBounkairCarpetFilterCategory,
  setHomeCurrentView,
} from "../redux/carpet";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { recordGaEvent } from "../helpers/GoogleAnalytics";

export interface DesktopNavProps {
  screenType: HomeScreenType;
}

const DesktopNav = ({ screenType }: DesktopNavProps) => {
  const dispatch = useDispatch();

  const { unreadMessageCount } = useSelector(
    (state: RootState) => state.member
  );
  const { newDoubleMatchesCount, newSentToMeCount, newWatchCount } =
    useSelector((state: RootState) => state.member.bonakirNotifications);
  const setCurrnetView = (view: HomeScreenType) =>
    dispatch(setHomeCurrentView(view));

  //TODO: Might be obsolete
  const IsUnreadBonakirNotif =
    newDoubleMatchesCount + newSentToMeCount + newWatchCount > 0;

  const IsUnreadWatchMe = newWatchCount > 0;

  console.log("DesktopNav newDoubleMatchesCount: ", newDoubleMatchesCount);
  console.log("DesktopNav newSentToMeCount: ", newSentToMeCount);
  console.log("DesktopNav newWatchCount: ", newWatchCount);

  console.log("DesktopNav IsUnreadBonakirNotif: ", IsUnreadBonakirNotif);

  const setMenu = () => {
    dispatch(
      setBounkairCarpetFilterCategory({
        // value: BounakirFilterType.BOUNAKIR_NEMU,
        value: BounakirFilterType.WATCHE_ME,
        text: "היכרויות",
      })
    );
  };

  const recordEvent = (
    element: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    let { target } = element;
    let anchorElement = target as HTMLAnchorElement;
    let label =
      anchorElement.textContent !== null ? anchorElement.textContent : "";
    recordGaEvent(
      GAEventNames.APP_ENGAGMENT,
      GACategoryName.COMMUNITY_SCREEN,
      GAActions.CLICK,
      label,
      GAUniqueEventIds.APP_ENGAGMENT
    );
  };

  const recordChatEvent = () => {
    recordGaEvent(
      GAEventNames.APP_ENGAGMENT,
      GACategoryName.SOCIAL_SCREEN,
      GAActions.CHAT,
      "open_chat",
      GAUniqueEventIds.APP_ENGAGMENT
    );
  };

  useLayoutEffect(() => {
    setCurrnetView(screenType);
  }, []);

  return (
    <div className="nav_sec desk wf-section">
      <div
        className="nav_block"
        onClick={() => {
          if (screenType === HomeScreenType.HOME) window.location.reload();
        }}
      >
        <NavLink
          className={
            screenType === HomeScreenType.HOME
              ? "nav_link w-inline-block"
              : "nav_link grey w-inline-block"
          }
          to={HOMEPAGE}
        >
          <div className="nav_icon">
            <img src="/assets/images/nav_ic_home.svg" loading="lazy" alt="" />
          </div>
          <div>אנשים</div>
        </NavLink>
      </div>
      <div className="nav_line" />
      <div onClick={recordChatEvent} className="nav_block">
        <NavLink
          className={
            screenType === HomeScreenType.CONVERSTAION
              ? "nav_link w-inline-block"
              : "nav_link grey w-inline-block"
          }
          to={CONVERSTAION}
        >
          <div className="nav_icon">
            <img src="/assets/images/nav_ic_chat.svg" loading="lazy" alt="" />
          </div>
          <div>צ'אט</div>
        </NavLink>
        {unreadMessageCount > 0 ? (
          <div className="message_num">
            <div>{unreadMessageCount}</div>
          </div>
        ) : null}
      </div>
      <div className="nav_line" />
      {/* <div className="nav_block">
                <NavLink className={screenType === HomeScreenType.BOUNAKIR ? "nav_link w-inline-block" : "nav_link grey w-inline-block"} onClick={setMenu} to={BOUNAKIR}>
                    <div className="nav_icon"><img src="/assets/images/nav_ic_shoshke.svg" loading="lazy" alt="" /></div>
                    <div>היכרויות</div>
                </NavLink>
                {
                    IsUnreadBonakirNotif ? <div className="message_num">
                        <div>חדש</div>
                    </div>
                        : null
                }
            </div> */}

      {/* <div className="nav_block">
        <NavLink
          className={
            screenType === HomeScreenType.BOUNAKIR
              ? "nav_link w-inline-block"
              : "nav_link grey w-inline-block"
          }
          onClick={setMenu}
          to={BOUNAKIR_WATCH_ME}
        >
          <div className="nav_icon">
            <img
              src="/assets/images/nav_ic_shoshke.svg"
              loading="lazy"
              alt=""
            />
          </div>
          <div>צפיות</div>
        </NavLink>
        {IsUnreadBonakirNotif ? (
          <div className="message_num">
            <div>חדש</div>
          </div>
        ) : null}
      </div> */}

      <div className="nav_block">
        <NavLink
          className={
            screenType === HomeScreenType.BOUNAKIR_WATCH_ME
              ? "nav_link w-inline-block"
              : "nav_link grey w-inline-block"
          }
          onClick={setMenu}
          to={BOUNAKIR_WATCH_ME}
        >
          <div className="nav_icon">
            <img
              // src="/assets/images/nav_ic_shoshke.svg"
              src="/assets/images/nav_ic_views.svg"
              loading="lazy"
              alt=""
            />
          </div>
          <div>צפו בי</div>
        </NavLink>
        {/* {IsUnreadBonakirNotif ? (
          <div className="message_num">
            <div>חדש</div>
          </div>
        ) : null} */}

        {IsUnreadWatchMe ? (
          <div className="message_num">
            <div>חדש</div>
          </div>
        ) : null}
      </div>

      <div className="nav_line" />

      <div className="nav_block">
        <NavLink
          className={
            screenType === HomeScreenType.BOUNKIR_LINKS
              ? "nav_link w-inline-block"
              : "nav_link grey w-inline-block"
          }
          // to={BOUNKIR_LINKS}
          to={{ pathname: "https://www.motke.co.il/%D7%A2%D7%96%D7%A8%D7%94" }}
          target="_blank"
        >
          {/* <div className="nav_icon motke">
                    <img src="/assets/images/nav_ic_motke.svg" loading="lazy" alt="motke_nav" />
                </div>
                <div>מוטק'ה</div> */}

          <div className="nav_icon motke">
            <img
              // src="/assets/images/nav_ic_motke.svg"
              src="/assets/images/nav_ic_motke_1.svg"
              loading="lazy"
              alt="motke_nav"
            />
          </div>
          <div>עזרה</div>
        </NavLink>
      </div>

      {/* <div className="nav_block">
                <NavLink className={screenType === HomeScreenType.BOUNKIR_LINKS ? "nav_link w-inline-block" : "nav_link grey w-inline-block"} to={BOUNKIR_LINKS}>
                    <div className="nav_icon"><img src="/assets/images/nav_ic_motke.svg" loading="lazy" alt="" /></div>
                    <div>מוטק׳ה</div>
                </NavLink>
            </div> */}
      <div className="nav_line" />
      <div className="nav_block">
        <NavLink
          className={
            screenType === HomeScreenType.MY_PROFILE
              ? "nav_link w-inline-block"
              : "nav_link grey w-inline-block"
          }
          to={MY_PROFILE}
        >
          <div className="nav_icon profile">
            <img
              src="/assets/images/nav_ic_profile.svg"
              loading="lazy"
              alt=""
            />
          </div>
          <div>פרופיל</div>
        </NavLink>
      </div>
      <div className="nav_line"></div>
      <div className="nav_block">
        <a
          href="https://www.motke.co.il/"
          target="_blank"
          className="motke_nav_link w-inline-block"
        >
          <img src="assets/images/logo_motke.svg" loading="lazy" alt="" />
        </a>
        <ul role="list" className="nav_sub_list w-list-unstyled">
          <li className="nuv_sub_item">
            <a
              href="https://www.motke.co.il/%D7%9B%D7%9C_%D7%94%D7%A7%D7%91%D7%95%D7%A6%D7%95%D7%AA"
              onClick={recordEvent}
              target="_blank"
              className="nuv_sub_link"
            >
              קבוצות
            </a>
          </li>
          <li className="nuv_sub_item">
            <a
              href="https://www.motke.co.il/%D7%99%D7%97%D7%A1%D7%99%D7%9D"
              onClick={recordEvent}
              target="_blank"
              className="nuv_sub_link"
            >
              מגזין
            </a>
          </li>
          <li className="nuv_sub_item">
            <a
              href="https://www.motke.co.il/%D7%AA%D7%99%D7%99%D7%A8%D7%95%D7%AA"
              onClick={recordEvent}
              target="_blank"
              className="nuv_sub_link"
            >
              טיולים
            </a>
          </li>
          <li className="nuv_sub_item">
            <a
              href="https://www.motke.co.il/%D7%91%D7%99%D7%9C%D7%95%D7%99%D7%99%D7%9D"
              onClick={recordEvent}
              target="_blank"
              className="nuv_sub_link"
            >
              מועדון תרבות
            </a>
          </li>
          <li className="nuv_sub_item">
            <a
              href="https://www.motke.co.il/%D7%9B%D7%9C_%D7%94%D7%91%D7%9C%D7%95%D7%92%D7%99%D7%9D"
              onClick={recordEvent}
              target="_blank"
              className="nuv_sub_link"
            >
              בלוגים
            </a>
          </li>
          <li className="nuv_sub_item">
            <a
              href="https://www.motke.co.il/%D7%9B%D7%9C_%D7%94%D7%9E%D7%95%D7%93%D7%A2%D7%95%D7%AA"
              onClick={recordEvent}
              target="_blank"
              className="nuv_sub_link"
            >
              לוח מודעות
            </a>
          </li>
          <li className="nuv_sub_item">
            <a
              href="https://www.motke.co.il/VOD"
              onClick={recordEvent}
              target="_blank"
              className="nuv_sub_link"
            >
              VOD
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default DesktopNav;
